module.exports = __webpack_public_path__ + "static/media/astronaut.cf946e90.png";